import React from "react";
import swal from 'sweetalert2';

const Alerts = () => { }

export default Alerts;

Alerts.ShowAlert = (ptitle, pmessage, picon) => {
    swal.fire({
        title: ptitle,
        html: pmessage,
        icon: picon,
        button: 'Accept',
    });
}

Alerts.ShowAlertFullScreen = (ptitle, pmessage, picon) => {
    swal.fire({
        title: ptitle,
        html: pmessage,
        icon: picon,
        button: 'Accept',
        grow: "fullscreen"
    });
}

Alerts.ShowAlertFullScreenCryptoCopy = (ptitle, pmessage, picon, descriptor, amount) => {
    swal.fire({
        title: ptitle,
        html: pmessage,
        icon: picon,
        button: 'Accept',
        grow: "fullscreen",
        didOpen: () => {
            const descriptorSpan = document.getElementById('copyable-descriptor');
            const descriptorIcon = document.getElementById('copy-icon');

            if (descriptorSpan && descriptorIcon) {
                descriptorIcon.addEventListener('click', () => {
                    navigator.clipboard.writeText(descriptor);
                    descriptorSpan.style.color = 'lightgreen';
                    setTimeout(() => {
                        descriptorSpan.style.color = '';
                    }, 2000);
                });
            }

            const amountSpan = document.getElementById('copyable-amount');
            const amountIcon = document.getElementById('copy-amount-icon');

            if (amountSpan && amountIcon) {
                amountIcon.addEventListener('click', () => {
                    navigator.clipboard.writeText(amount);
                    amountSpan.style.color = 'lightgreen';
                    setTimeout(() => {
                        amountSpan.style.color = '';
                    }, 2000);
                });
            }
        }
    });
};


Alerts.ShowP2PAlert = (ptitle, pmessage, picon) => {
    swal.fire({
        title: ptitle,
        html: pmessage,
        icon: picon,
        button: 'Accept',
        width: 800,
    });
}


Alerts.SessionAlert = (ptitle, pmessage, picon) => {
    swal.fire({
        title: ptitle,
        html: pmessage,
        icon: picon,
        buttons: false,
        closeOnEsc: false,
        closeOnClickOutside: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: false,
        allowOutsideClick: false
       
    });
}
